import { render, staticRenderFns } from "./personalInfo.vue?vue&type=template&id=5be4e05f"
import script from "./personalInfo.vue?vue&type=script&lang=js"
export * from "./personalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports